import { GrandItem } from "./rabac";

export const grantListRABAC: GrandItem[] = [
  { resource: '', action: '' },

  { resource: 'home', action: 'list' },
  { resource: 'config', action: 'list' },
  { resource: 'content', action: 'list' },
  { resource: 'content', action: 'show' },

  { role: 'pro_band0', resource: 'calendar', action: 'list' },
  { role: 'pro_band1', resource: 'calendar', action: 'list' },
  { role: 'pro_band2', resource: 'calendar', action: 'list' },
  { role: 'user_band0', resource: 'calendar', action: 'list' },
  { role: 'user_band1', resource: 'calendar', action: 'list' },
  { role: 'user_band2', resource: 'calendar', action: 'list' },
  { role: 'user_band3', resource: 'calendar', action: 'list' },

  { role: 'user_band0', resource: 'appointment', action: 'create' },
  { role: 'user_band1', resource: 'appointment', action: 'create' },
  { role: 'user_band2', resource: 'appointment', action: 'create' },
  { role: 'user_band3', resource: 'appointment', action: 'create' },

  { role: 'user_band1', resource: 'appointment', action: 'show' },
  { role: 'user_band2', resource: 'appointment', action: 'show' },
  { role: 'user_band3', resource: 'appointment', action: 'show' },

  { role: 'pro_band0', resource: 'onboarding', action: 'list' },
  { role: 'pro_band0', resource: 'successful_payment', action: 'list' },
  { role: 'user_band0', resource: 'successful_payment', action: 'list' },
  { resource: 'pqrs', action: 'show' },

  { role: 'user_band0', resource: 'contact-professional', action: 'list' },
  { role: 'user_band1', resource: 'contact-professional', action: 'list' },
  { role: 'user_band2', resource: 'contact-professional', action: 'list' },
  { role: 'user_band3', resource: 'contact-professional', action: 'list' },

  { role: 'user_band1', resource: 'contact-professional', action: 'show' },
  { role: 'user_band2', resource: 'contact-professional', action: 'show' },
  { role: 'user_band3', resource: 'contact-professional', action: 'show' },

  { role: 'user_band0', resource: 'helps', action: 'list' },
  { role: 'user_band1', resource: 'helps', action: 'list' },
  { role: 'user_band2', resource: 'helps', action: 'list' },
  { role: 'user_band3', resource: 'helps', action: 'list' },

  { role: 'pro_band1', resource: 'group-event', action: 'create' },
  { role: 'pro_band2', resource: 'group-event', action: 'create' },

  { role: 'user_band1', resource: 'helps', action: 'show' },
  { role: 'user_band2', resource: 'helps', action: 'show' },
  { role: 'user_band3', resource: 'helps', action: 'show' },
  { role: 'pro_band1', resource: 'helps', action: 'show' },
  { role: 'pro_band2', resource: 'helps', action: 'show' },

  { role: 'user_band1', resource: 'assistance', action: 'show' },
  { role: 'user_band2', resource: 'assistance', action: 'show' },
  { role: 'user_band3', resource: 'assistance', action: 'show' },
  { role: 'pro_band1', resource: 'assistance', action: 'show' },
  { role: 'pro_band2', resource: 'assistance', action: 'show' },

  { role: 'user_band0', resource: 'availability', action: 'list' },
  { role: 'user_band1', resource: 'availability', action: 'list' },
  { role: 'user_band2', resource: 'availability', action: 'list' },
  { role: 'user_band3', resource: 'availability', action: 'list' },

  { role: 'pro_band1', resource: 'availability', action: 'create' },
  { role: 'pro_band2', resource: 'availability', action: 'create' },

]